import { render, staticRenderFns } from "./TableMemberTypesActiveTxItem.vue?vue&type=template&id=13f3277e&"
import script from "./TableMemberTypesActiveTxItem.vue?vue&type=script&lang=js&"
export * from "./TableMemberTypesActiveTxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f3277e')) {
      api.createRecord('13f3277e', component.options)
    } else {
      api.reload('13f3277e', component.options)
    }
    module.hot.accept("./TableMemberTypesActiveTxItem.vue?vue&type=template&id=13f3277e&", function () {
      api.rerender('13f3277e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableMemberTypesActiveTxItem.vue"
export default component.exports